import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';
import myBookingApi from '../../../api/mybooking/mybooking';
import languageService from '../../../services/language.service';
import cacheService from '../../../services/cache.service';
import helpCentreService from '../../../services/helpCentre.service';
import referenceFormatter from '../../../common/filters/referenceFormatter';

const loginModule = angular.module('login', [
    uiRouter,
    myBookingApi,
    cacheService,
    languageService,
    helpCentreService,
    referenceFormatter
])
    .config(($stateProvider, $urlMatcherFactoryProvider) => {
        "ngInject";

        $urlMatcherFactoryProvider.strictMode(false);
        $stateProvider
            .state('auth.login', {
                url: '/login?reference&email',
                views: {
                    'main@': {
                        template: '<login></login>'
                    }
                }
            });
    })
    .component('login', loginComponent)
    .name;

export default loginModule;


// WEBPACK FOOTER //
// ./client/app/routes/auth/login/login.js